var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":_vm.$t('cloudenv.text_491')}}),_c('a-alert',{staticClass:"mt-2",attrs:{"message":_vm.$t('cloudenv.cloudgroup_desc'),"type":"info"}}),_c('page-body',[_c('list',{attrs:{"id":_vm.listId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }